import { useInfiniteQuery } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { InfiniteQueryFunction } from '@frontend/api';

import type {
  SearchErpPartsByPartNumberData,
  SearchErpPartsByPartNumberQueryKey,
  UseSearchErpPartsByPartNumberParams,
} from './types';
import { getSearchErpPartsByPartNumberQueryKey } from './util';

export const useSearchErpPartsByPartNumber: InfiniteQueryFunction<
  SearchErpPartsByPartNumberData,
  [UseSearchErpPartsByPartNumberParams],
  SearchErpPartsByPartNumberQueryKey
> = (params, queryFunctionOptions = {}) => {
  const { requestOptions, queryOptions } = queryFunctionOptions;
  const request = useRequest(requestOptions);

  const queryKey = getSearchErpPartsByPartNumberQueryKey(params);

  return useInfiniteQuery({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal, pageParam }) => {
      return request<SearchErpPartsByPartNumberData>(
        '/search/erp_part_importer',
        {
          init: {
            method: 'GET',
            signal,
          },
          query: {
            q: params.partNumber,
            pno: params.isPartNumberOnlySearch,
            root_only: params.isRootPartOnlySearch,
            start: pageParam,
          },
        },
      );
    },
    getNextPageParam: () => undefined,
  });
};
